import {Component, Input, OnInit} from '@angular/core';
import {IconComponent} from '../../icons-svgs/icons-svgs.component';
import {Notification} from '../../../../models/notification';
import {Router} from '@angular/router';
import {NgForOf, NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {UserService} from '../../../../services/user-services/user.service';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [
    IconComponent,
    NgIf,
    TranslateModule,
    NgForOf
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  animations: [
    trigger('fadeSlideInOut', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateY(-25px)', position: 'absolute'}),
        animate('250ms', style({opacity: 1, transform: 'translateY(0)', position: 'relative'})),
      ]),
      transition(':leave', [
        animate('200ms', style({opacity: 0, transform: 'translateX(350px)', position: 'absolute'})),
      ]),
    ]),
  ]
})
export class NotificationsComponent implements OnInit {
  @Input() public items: Notification[];
  public isMobile: boolean = false;
  public displayedIndex: number = 0;

  constructor(
    private router: Router,
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
    this.checkNotificationInLocal();
  }

  public close(): void {
    // Met la notification en suspens pendant 24h
    const displayedNotification = this.items[this.displayedIndex];
    const today = new Date();
    today.setHours(today.getHours() + 24);
    localStorage.setItem('asideNotification_' + displayedNotification.id, today.toISOString());

    // Passe à la notification suivante
    this.displayedIndex += 1;
  }

  /**
   * Filtre les notifications : si l'utilisateur a fermé la notification dans les dernières 24 heures, on ne lui montre pas
   */
  private checkNotificationInLocal(): void {
    this.items = this.items.filter(i => {
      if (localStorage.getItem('asideNotification_' + i.id)) {
        const asideNotificationTime = new Date(localStorage.getItem('asideNotification_' + i.id));
        const today = new Date();
        const diff = today.getTime() - asideNotificationTime.getTime();
        if (diff / (1000 * 3600 * 24) >= 1) {
          localStorage.removeItem('asideNotification_' + i.id);
          return i;
        }
      } else {
        return i;
      }
    });
  }

  public goToPage(item: Notification): void {
    if (item.item_id) {
      localStorage.setItem('tempRedirect', item.item_id.toString());
    }
    this.router.navigate([item.notification.redirect]).then(() => {
      this.close();
    });
  }

  public trackById(index: number, item: Notification): number {
    return item.id;
  }

}
